import {
  FeatureEvaluationResult,
  FeatureResolutionSource,
  FeatureResolver,
  FeatureResolverContext,
} from '../evaluator';

/**
 * Reference resolver skeleton for subscription-tier gating.
 * Register via createFeatureEvaluator() when billing integration is added.
 */
export const subscriptionFeatureResolver: FeatureResolver = {
  name: 'subscription',
  resolve(context: FeatureResolverContext): FeatureEvaluationResult | null {
    void context;
    return null;
  },
};

/**
 * Reference resolver skeleton for creator plan gating.
 */
export const creatorPlanFeatureResolver: FeatureResolver = {
  name: 'creator_plan',
  resolve(context: FeatureResolverContext): FeatureEvaluationResult | null {
    void context;
    return null;
  },
};

/**
 * Reference resolver skeleton for beta program enrollment.
 */
export const betaProgramFeatureResolver: FeatureResolver = {
  name: 'beta_program',
  resolve(context: FeatureResolverContext): FeatureEvaluationResult | null {
    void context;
    return null;
  },
};

/**
 * Reference resolver skeleton for internal testing cohorts.
 */
export const internalAccessFeatureResolver: FeatureResolver = {
  name: 'internal_access',
  resolve(context: FeatureResolverContext): FeatureEvaluationResult | null {
    void context;
    return null;
  },
};

/**
 * Reference resolver skeleton for client platform restrictions.
 */
export const platformFeatureResolver: FeatureResolver = {
  name: 'platform',
  resolve(context: FeatureResolverContext): FeatureEvaluationResult | null {
    void context;
    return null;
  },
};

/** Resolver set reserved for future contextual gating. All are no-ops today. */
export const FUTURE_FEATURE_RESOLVERS: FeatureResolver[] = [
  platformFeatureResolver,
  internalAccessFeatureResolver,
  betaProgramFeatureResolver,
  subscriptionFeatureResolver,
  creatorPlanFeatureResolver,
];

export { FeatureResolutionSource };
